// extracted by mini-css-extract-plugin
export default {"image":"AddNewBoard_image__6i4FU","tooltip":"AddNewBoard_tooltip__CFBwu","button":"AddNewBoard_button__a2Ild","picker":"AddNewBoard_picker__-4Nxn"};